import { create } from 'zustand'

const initialState = {
  formData: null,
  overrideData: {},
  forkedStudyData: {
    ctg: {},
    eudract: {}
  },
  attachedDocuments: [],
  translationsData: {}
}

const useAuthoringDataStore = create((set) => ({
  ...initialState,
  setFormData: (formData) => set({ formData }),
  setOverrideData: (overrideData) => set({ overrideData }),
  setForkedStudyData: (forkedStudyData) => set({ forkedStudyData }),
  setAttachedDocuments: (attachedDocuments) => set({ attachedDocuments }),
  setTranslationsData: (translationsData) => set({ translationsData }),
  resetAuthoringDataStore: () => set(initialState),
}))

export default useAuthoringDataStore;